module.exports = __webpack_public_path__ + "static/img/21.d8a348fa.jpg";